import React from 'react'
import { PropTypes } from 'prop-types'
import { videoblue } from '../../../utils/sitecolors'
import logo from '../../../images/PinStar-15PX.png'

const SeasonHeader = ({ seasonyears }) => {
   return(
      <h4  style={{ color:videoblue }}>
        <img src={logo} style={{ maxWidth:'30px', marginTop:'-3px' }} />
         &nbsp;{seasonyears}&nbsp;&nbsp;Collegiate Season
     </h4>
   )
}
SeasonHeader.propTypes = {
    seasonyears: PropTypes.string
}
export default SeasonHeader


// WEBPACK FOOTER //
// ./src/containers/season/Components/SeasonHeader.js